import { buildHaspDark }      from './hasp-dark/index.js';
import { buildHaspLight }     from './hasp-light/index.js';
import { buildMono }          from './mono/index.js';
import { buildMaterialDark }  from './material-dark/index.js';
import { buildMaterialLight } from './material-light/index.js';
import { normalise }          from './themeUtils.js';

const builders = {
    haspdark:      buildHaspDark,
    hasplight:     buildHaspLight,
    mono:          buildMono,
    materialdark:  buildMaterialDark,
    materiallight: buildMaterialLight,
};

// Map legacy display names (from old themeLookup) → machine names
const displayToMachine = {
    'hasp light':     'hasplight',
    'hasp dark':      'haspdark',
    'mono':           'mono',
    'material light': 'materiallight',
    'material dark':  'materialdark',
};

/**
 * Normalise a theme identifier — accepts machine names ('haspdark'),
 * display names ('Hasp Dark'), or numeric option strings ('2').
 */
function resolveThemeName(name) {
    if (!name) return 'haspdark';
    if (builders[name]) return name;
    // Try display-name lookup (case-insensitive)
    const lower = String(name).toLowerCase().trim();
    if (displayToMachine[lower]) return displayToMachine[lower];
    // Try numeric option (1=hasplight, 2=haspdark, 3=mono, 4=materiallight, 5=materialdark)
    const numMap = { '1': 'hasplight', '2': 'haspdark', '3': 'mono', '4': 'materiallight', '5': 'materialdark' };
    if (numMap[lower]) return numMap[lower];
    return 'haspdark';
}

/**
 * Return a fully-resolved theme object for the given theme name and colours.
 * Accepts machine names, display names, or numeric IDs.
 * Primary/secondary may include an alpha suffix (#rrggbbaa) which is stripped.
 */
export function getTheme(name, primary_color, secondary_color) {
    const builder   = builders[resolveThemeName(name)] ?? buildHaspDark;
    const primary   = normalise(primary_color   ?? '#00aaff');
    const secondary = normalise(secondary_color ?? '#ff9966');
    return builder(primary, secondary);
}

export { resolveThemeName };

// Legacy default export — kept so any code that does theme['dark'] still works
// during the transition; it resolves to HASP Dark with default colours.
export const theme = {
    dark: buildHaspDark('#00aaff', '#ff9966'),
};
